import { api } from "./api";
import { ILoginForm, IRegistrForm } from "../../shared/interfaces/auth";

export async function logIn(body: ILoginForm) {
    try {
        const response = await api.post("users/login", body, {
            withCredentials: true,
        });
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}

export async function registration(body: IRegistrForm) {
    try {
        const response = await api.post("users/createemployee", body, {
            withCredentials: true,
        });
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}

export async function logOut() {
    try {
        const response = await api.post(
            "logout",
            {},
            {
                withCredentials: true,
            },
        );
        return response;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}
